import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Staircase = () => {
  const { t, updateAddress, errors, staircase, isApartment, showStaircase, showAddressFields } = useAddress()

  if (!showStaircase || !showAddressFields || !isApartment) {
    return null
  }

  return (
    <FormControl error={getError('staircase', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.staircase')}
        onBlur={staircase => updateAddress({ staircase })}
        currentValue={staircase}
      />
    </FormControl>
  )
}

export default Staircase
